import React from 'react';
import ReactDOM from 'react-dom/client';
import { Auth0Provider } from '@auth0/auth0-react';
import './index.css';
import App from './App';
import { auth0Config } from './auth0-config';

// Clear stale Auth0 data on fresh page load (not OAuth redirects)
const urlParams = new URLSearchParams(window.location.search);
const isOAuthRedirect = urlParams.has('code') || urlParams.has('state') || urlParams.has('error');

if (!isOAuthRedirect) {
  // Clear any stale Auth0 SPA data that might cause slow logins
  const auth0Keys = Object.keys(localStorage).filter(key => 
    key.includes('@@auth0spajs@@')
  );
  
  if (auth0Keys.length > 0) {
    console.log(`[Index] Clearing ${auth0Keys.length} stale Auth0 cache entries on fresh load`);
    auth0Keys.forEach(key => {
      localStorage.removeItem(key);
    });
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Auth0Provider
      domain={auth0Config.domain}
      clientId={auth0Config.clientId}
      authorizationParams={{
        redirect_uri: auth0Config.redirectUri,
        audience: auth0Config.audience,
        scope: auth0Config.scope
      }}
      cacheLocation="localstorage"
      useRefreshTokens={true}
      useRefreshTokensFallback={false}
    >
      <App />
    </Auth0Provider>
  </React.StrictMode>
);